import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  del,
  formDataPatch,
  formDataPost,
  get,
  patch,
  post,
} from "helpers/api_helper";
import {
  ADD_CITY,
  DELETE_CITY,
  GET_ALL_CITY,
  GET_CITY_DETAILS,
  GET_CITY_LIST,
  UPDATE_CITY,
  UPDATE_CITY_STATUS,
  GET_ALL_COUNTRIES,
} from "helpers/url_helper";

export const getAllCities = createAsyncThunk(GET_ALL_CITY, async (payload) => {
  const response = await post(GET_ALL_CITY, payload);
  return response;
});

export const getCityList = createAsyncThunk(GET_CITY_LIST, async (payload) => {
  const response = await get(GET_CITY_LIST);
  return response;
});

export const addCity = createAsyncThunk(ADD_CITY, async (payload) => {
  const response = await formDataPost(ADD_CITY, payload);
  return response;
});

export const updateCity = createAsyncThunk(UPDATE_CITY, async (payload) => {
  const response = await formDataPatch(UPDATE_CITY, payload);
  return response;
});

export const deleteCity = createAsyncThunk(DELETE_CITY, async (payload) => {
  const response = await del(DELETE_CITY, payload);
  return response;
});

export const updateCityStatus = createAsyncThunk(
  UPDATE_CITY_STATUS,
  async (payload) => {
    const response = await patch(UPDATE_CITY_STATUS, payload);
    return response;
  }
);

export const getCityDetails = createAsyncThunk(GET_CITY_DETAILS, async (payload) => {
  const response = await post(GET_CITY_DETAILS, payload);
  return response;
});

// For getting country (Tod space work)

export const getAllCountries = createAsyncThunk(GET_ALL_COUNTRIES, async (payload) => {
  const response = await get(GET_ALL_COUNTRIES);
  return response;
});
